import './index.scss'
import Swiper from 'swiper/swiper-bundle.min.js'
$("header .nav li#nav1").addClass("active");
var swiper = new Swiper(".index-banner .mySwiper", {
    observer:true,//修改swiper自己或子元素时，自动初始化swiper
    observeParents:true,//修改swiper的父元素时，自动初始化swiper
    loop:true,
    speed:1500,
    autoplay: {
        delay: 4000,
    },
    pagination: {
        el: '.index-banner .swiper-pagination',
        clickable: true,
    },
});
// var productSwiper = new Swiper(".section1 .mySwiper", {
// 	slidesPerView: 3,
// 	spaceBetween: '1.55%',
//     watchSlidesProgress: true,
//     speed:2000,
//     autoplay: {
//         delay: 5000,
//         disableOnInteraction: false,
//     },
// 	breakpoints: {
//         320: { //当屏幕宽度大于等于320
// 			slidesPerView: 2,
// 			slidesPerGroup: 2,
// 			spaceBetween: '1%',
//         },
//         768: { //当屏幕宽度大于等于768 
//             slidesPerView: 3,
// 			slidesPerGroup: 3,
// 			spaceBetween: '1.55%',
//         },
//         1280: { //当屏幕宽度大于等于1280
// 			slidesPerGroup: 4,
//             slidesPerView: 4,
//             spaceBetween: '1.55%',
//         }
//     },
//     pagination: {
//         el: ".section1 .swiper-pagination",
//         clickable: true,
//       },
// });
